import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from '@app/base/alerts/alert.service';
import { AccountService, ConstantsService, LookupsService, SessionService } from '@app/core/services';
import { focusFirstInvalidField, triggerFormValidation } from '@app/shared/functions';
import { SocoHttpService } from '@app/soco/http';
import { BuilderService } from '../../base/services';

declare var swal: any;
require('sweetalert');

interface SubName {
  id: number;
  itemName: string;
}

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.css']
})

export class NewUserComponent implements OnInit {
  userForm: FormGroup;
  addNewUser: any = {};
  builderId: string;
  alertMsg: any = [];
  subList: SubName[];

  constructor(public constantsSvc: ConstantsService, public socoHttp: SocoHttpService, private datePipe: DatePipe,
    private builderSvc: BuilderService,  public accountSvc: AccountService, public session: SessionService,
    @Inject(Router) private router: Router, public lookupSvc: LookupsService, private alertService: AlertService) {
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
      this.session.builderData.subscribe(result => {
        if (result) {
          this.socoHttp.hidePleaseWait('ContainerAwaiter1');
          this.builderId = result.BuilderId[0];
          this.subList = [];
          console.log(this.builderId);
          this.subList.push({ id: +this.builderId, itemName: result.CompanyName });
          for ( const i of result.BuilderMapping ) {
           if ( i.status === 'Approved' ) {
          this.subList.push({ id: +i.subsidiaryId, itemName: i.subsidiaryName.toString()});
           }
          }
        } else {
          this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
            result => {
              if (result.data !== undefined && result.data.length !== 0) {
               this.builderId = result.data.id;
               this.subList = [];
               this.subList.push({ id: +this.builderId, itemName: this.accountSvc.account.user.company });
               for ( const i of result.data.builderMapping ) {
                if ( i.status === 'Approved' ) {
                this.subList.push({ id: +i.subsidiaryId, itemName: i.subsidiaryName.toString() });
                }
            }
      }
    });
        }
        },
        error => {
          this.socoHttp.hidePleaseWait('ContainerAwaiter1');
        });

        const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
          if (subscribe && val) {
            subscribe.unsubscribe();
          }
          // Banner message for Home page
          if (val) {
             this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'New User'
          ));
            this.alertService.info(this.alertMsg.message);
          }
        });
    }

  ngOnInit() {
    this.userForm = new FormGroup({
      firstName: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50)]
      ),
      lastName: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50)]
      ),
      subsidaryCompany: new FormControl(
        null,
        [Validators.required]
        ),
      email: new FormControl(
        null,
        [Validators.required, Validators.maxLength(50), Validators.pattern(this.constantsSvc.emailPattern)]
      ),
      contactNumber: new FormControl(
        null,
        [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]
      )
    });
  }

  addUser() {
    if (this.userForm.valid) {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter1');
    this.addNewUser.id = this.userForm.controls['subsidaryCompany'].value.id;
    this.addNewUser.userId = this.userForm.controls['email'].value;
    this.addNewUser.userName = this.userForm.controls['firstName'].value + ' ' + this.userForm.controls['lastName'].value;
    this.addNewUser.firstName = this.userForm.controls['firstName'].value;
    this.addNewUser.lastName = this.userForm.controls['lastName'].value;
    this.addNewUser.email = this.userForm.controls['email'].value;
    this.addNewUser.Status = 'Requested';
    this.addNewUser.communicationTypeCd = null;
    this.addNewUser.iaAdmin = null;
    this.addNewUser.recCreatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.addNewUser.recUpdatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.addNewUser.recCreatedBy =  this.userForm.controls['email'].value;
    this.addNewUser.recUpdatedBy = this.userForm.controls['email'].value;
    this.addNewUser.contactName2Phone = this.userForm.controls['contactNumber'].value;
    this.addNewUser.contactName2Extn = null;
    this.addNewUser.comments = null;
    this.addNewUser.approveRejectDTTM = null;
    this.addNewUser.approveRejectBy = null;
    this.builderSvc.addUser(this.addNewUser).subscribe(result => {
      if (result.data.companyName === '') {
        swal(this.constantsSvc.warningSwal, this.constantsSvc.builderUserAddWarning, this.constantsSvc.warningSwal);
        this.socoHttp.hidePleaseWait('ContainerAwaiter1');
      } else {
        swal(this.constantsSvc.successSwal1, this.constantsSvc.builderNewUserAdd, this.constantsSvc.successSwal);
        this.resetForm();
        this.socoHttp.hidePleaseWait('ContainerAwaiter1');
      }
    }, error => {
      swal(this.constantsSvc.errorSwal1, this.constantsSvc.builderUserAddFail, this.constantsSvc.errorSwal);
      this.resetForm();
      this.socoHttp.hidePleaseWait('ContainerAwaiter1');
    });
  } else {
    triggerFormValidation(this.userForm);
    focusFirstInvalidField(this.userForm);
  }

  }

  resetForm() {
    this.userForm.reset();
  }

      // To go to builder home page
      navigateHome() {
        this.session.GetBcaData(null);
        this.router.navigate([
          this.session.paramLdc.toLowerCase(),
          'builder',
          'home'
          ]);
      }

}
